import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import {
  getAuthState,
  hasStoredAuth,
  clearStoredVars,
  storeUserDetails
} from '../utils/jwt-helpers';

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: null,
    errors: []
  },
  reducers: {
    reloadFromCookie: (state, action) => {
      const authDetails = getAuthState();
      if (authDetails.authenticated) {
        state.user = authDetails.user;
      }
    },
    setUser: (state, action) => {
      storeUserDetails(action.payload);
      state.user = action.payload;
      state.errors = [];
    },
    removeUser: (state, action) => {
      clearStoredVars();
      state.user = null;
      state.errors = [];
    },
    clearError: (state, action) => {
      state.errors = [];
    }
  }
});

export const selectUser = (state) => state.user.user;

export const isAuthenticated = (state) => {
  const authState = getAuthState();
  return (!_.isEmpty(state.user.user) && !_.isEmpty(authState.user));
}

export const userRoles = (state) => {
  try {
    return state.user.user.roles;
  } catch {
    return [];
  }
};

export const hasErrors = (state) => state.user.errors.length > 0;

export const selectErrors = (state) => state.user.errors;

export const { reloadFromCookie, setUser, removeUser, clearError } = userSlice.actions;

export default userSlice.reducer;
